// Knowledge Graph mock data
export const knowledgeGraphMockData = {
  nodes: [
    // Customer nodes
    { id: "customer-1", label: "John Smith", type: "CUSTOMER" },
    { id: "customer-2", label: "Alice Johnson", type: "CUSTOMER" },
    { id: "customer-3", label: "Robert Davis", type: "CUSTOMER" },
    { id: "customer-4", label: "Emma Wilson", type: "CUSTOMER" },
    { id: "customer-5", label: "Michael Brown", type: "CUSTOMER" },
    
    // Product nodes
    { id: "product-1", label: "BILLY Bookcase", type: "PRODUCT" },
    { id: "product-2", label: "POÄNG Chair", type: "PRODUCT" },
    { id: "product-3", label: "MALM Bed Frame", type: "PRODUCT" },
    { id: "product-4", label: "KALLAX Shelf Unit", type: "PRODUCT" },
    { id: "product-5", label: "HEMNES Dresser", type: "PRODUCT" },
    
    // Category nodes
    { id: "category-1", label: "Living Room", type: "CATEGORY" },
    { id: "category-2", label: "Bedroom", type: "CATEGORY" },
    { id: "category-3", label: "Office", type: "CATEGORY" },
    { id: "category-4", label: "Kitchen", type: "CATEGORY" },
    
    // Topic nodes
    { id: "topic-1", label: "Assembly Help", type: "TOPIC" },
    { id: "topic-2", label: "Product Advice", type: "TOPIC" },
    { id: "topic-3", label: "Delivery Issue", type: "TOPIC" },
    { id: "topic-4", label: "Returns", type: "TOPIC" },
    { id: "topic-5", label: "Product Quality", type: "TOPIC" },
    
    // Context nodes 
    { id: "context-1", label: "Moving to New Home", type: "CONTEXT" },
    { id: "context-2", label: "Redecorating", type: "CONTEXT" },
    { id: "context-3", label: "Small Space Living", type: "CONTEXT" },
    { id: "context-4", label: "Home Office Setup", type: "CONTEXT" },
    
    // Interaction nodes
    { id: "interaction-1", label: "Website Purchase", type: "INTERACTION" },
    { id: "interaction-2", label: "In-Store Visit", type: "INTERACTION" },
    { id: "interaction-3", label: "Customer Service Call", type: "INTERACTION" },
    { id: "interaction-4", label: "App Purchase", type: "INTERACTION" }
  ],
  
  edges: [
    // Customer to Product edges (purchased)
    { source: "customer-1", target: "product-1", label: "PURCHASED" },
    { source: "customer-1", target: "product-3", label: "PURCHASED" },
    { source: "customer-2", target: "product-2", label: "PURCHASED" },
    { source: "customer-2", target: "product-4", label: "PURCHASED" },
    { source: "customer-3", target: "product-5", label: "PURCHASED" },
    { source: "customer-3", target: "product-1", label: "PURCHASED" },
    { source: "customer-4", target: "product-3", label: "PURCHASED" },
    { source: "customer-5", target: "product-2", label: "PURCHASED" },
    { source: "customer-5", target: "product-5", label: "PURCHASED" },
    
    // Customer to Product edges (viewed)
    { source: "customer-1", target: "product-2", label: "VIEWED" },
    { source: "customer-1", target: "product-4", label: "VIEWED" },
    { source: "customer-2", target: "product-1", label: "VIEWED" },
    { source: "customer-2", target: "product-3", label: "VIEWED" },
    { source: "customer-3", target: "product-4", label: "VIEWED" },
    { source: "customer-4", target: "product-5", label: "VIEWED" },
    { source: "customer-4", target: "product-2", label: "VIEWED" },
    { source: "customer-5", target: "product-4", label: "VIEWED" },
    
    // Product to Category edges
    { source: "product-1", target: "category-1", label: "BELONGS_TO" },
    { source: "product-1", target: "category-3", label: "BELONGS_TO" },
    { source: "product-2", target: "category-1", label: "BELONGS_TO" },
    { source: "product-3", target: "category-2", label: "BELONGS_TO" },
    { source: "product-4", target: "category-1", label: "BELONGS_TO" },
    { source: "product-4", target: "category-3", label: "BELONGS_TO" },
    { source: "product-5", target: "category-2", label: "BELONGS_TO" },
    
    // Customer to Topic edges
    { source: "customer-1", target: "topic-1", label: "DISCUSSED" },
    { source: "customer-2", target: "topic-3", label: "DISCUSSED" },
    { source: "customer-3", target: "topic-2", label: "DISCUSSED" },
    { source: "customer-4", target: "topic-4", label: "DISCUSSED" },
    { source: "customer-5", target: "topic-5", label: "DISCUSSED" },
    { source: "customer-5", target: "topic-1", label: "DISCUSSED" },
    
    // Customer to Context edges
    { source: "customer-1", target: "context-1", label: "HAS_CONTEXT" },
    { source: "customer-2", target: "context-2", label: "HAS_CONTEXT" },
    { source: "customer-3", target: "context-3", label: "HAS_CONTEXT" },
    { source: "customer-4", target: "context-1", label: "HAS_CONTEXT" },
    { source: "customer-5", target: "context-4", label: "HAS_CONTEXT" },
    
    // Customer to Interaction edges
    { source: "customer-1", target: "interaction-1", label: "ENGAGED_VIA" },
    { source: "customer-2", target: "interaction-2", label: "ENGAGED_VIA" },
    { source: "customer-3", target: "interaction-3", label: "ENGAGED_VIA" },
    { source: "customer-4", target: "interaction-4", label: "ENGAGED_VIA" },
    { source: "customer-5", target: "interaction-2", label: "ENGAGED_VIA" },
    
    // Topic to Product edges
    { source: "topic-1", target: "product-1", label: "RELATED_TO" },
    { source: "topic-1", target: "product-3", label: "RELATED_TO" },
    { source: "topic-2", target: "product-2", label: "RELATED_TO" },
    { source: "topic-3", target: "product-4", label: "RELATED_TO" },
    { source: "topic-4", target: "product-5", label: "RELATED_TO" },
    { source: "topic-5", target: "product-3", label: "RELATED_TO" },
    
    // Context to Product edges
    { source: "context-1", target: "product-3", label: "INTERESTS" },
    { source: "context-1", target: "product-5", label: "INTERESTS" },
    { source: "context-2", target: "product-2", label: "INTERESTS" },
    { source: "context-3", target: "product-4", label: "INTERESTS" },
    { source: "context-4", target: "product-1", label: "INTERESTS" }
  ]
};